import { Component } from '@angular/core';
import { SharedBeneficiarySelectionComponent } from '@pages/send-money/components/beneficiary-selection/shared-beneficiary-selection.component';
import { SharedBeneficiarySelectionModule } from '@pages/send-money/components/beneficiary-selection/shared-beneficiary-selection.module';
import { PeerToPeerComponent } from '../peer-to-peer/peer-to-peer.component';

@Component({
    standalone: true,
    selector: 'app-beneficiary-selection',
    templateUrl: './beneficiary-selection.component.html',
    styleUrls: ['./beneficiary-selection.component.scss'],
    imports: [SharedBeneficiarySelectionModule],
})
export class BeneficiarySelectionComponent extends SharedBeneficiarySelectionComponent {
    override ngOnInit(): void {
        super.ngOnInit();
        this.redirectToComponent = PeerToPeerComponent;
    }
}
